import React from 'react';

import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import { IHeroMaskCardFragment } from 'generated/sanity-graphql';
import { useUIContext } from 'state/ui';
import { primitive } from 'styles/constants/primitives';

const Section = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  position: relative;
  width: 100%;
  background: ${p => p.theme.token('background-pattern')};

  ${Styles.desktop`
    top: -${primitive.$spacing4};
    grid-template-columns: 1fr 1fr 1fr;
    margin-left: auto;
    margin-right: auto;
    max-width: ${Styles.layout.sectionMaxWidth};
    padding-top: 0;
    width: calc(100% - 6rem);
    border-radius: ${Styles.borderRadius};
    box-shadow: ${Styles.boxShadow};
  `}
`;

const Card = styled.span`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: ${primitive.$spacing10} ${primitive.$spacing8} ${primitive.$spacing10};
  align-items: center;

  ${Styles.mobile`
    padding: ${primitive.$spacing4} ${primitive.$spacing6};
    flex-direction: row-reverse;
    &:nth-child(3n+3) {
      flex-direction: row;
    }
    & > img {
      width: 33%;
    }
  `}
`;

const TextContainer = styled.div`
  ${Styles.mobile`
    padding: ${primitive.$spacing4};
  `}
`;

const CardHeading = styled.h4`
  color: ${p => p.theme.token('text-default')};
  font: ${brandFont.headerTwo};
  line-height: 1;
  margin: ${primitive.$spacing4} auto;
  ${Styles.desktop`
    text-align: center;
  `}
`;

const CardDescription = styled.p`
  margin: 0;
  max-width: 30rem;
  ${Styles.desktop`
    text-align: center;
  `}
`;

const LineBreak = styled.hr`
  border-width: 0px 0px 2px 0px;
  border-color: ${p => p.theme.token('border-color-options')};
  width: 80%;
  &:last-child {
    display: none;
  }
  ${Styles.desktop`
    display: none;
  `}
`;

const HeroMaskCards: React.FC<{ cards: IHeroMaskCardFragment[] }> = ({ cards }) => {
  const { buildImageUrl } = useUIContext();

  return (
    <Section>
      {cards.map(card => (
        <React.Fragment key={card._key || ''}>
          <Card>
            {card.image && card.image.asset && card.title && card.title?.locale && (
              <img src={buildImageUrl(card.image, { height: 140 })} alt={card.title?.locale} />
            )}
            <TextContainer>
              {card.title && <CardHeading>{card.title?.locale}</CardHeading>}
              {card.description && <CardDescription>{card.description?.locale}</CardDescription>}
            </TextContainer>
          </Card>
          <LineBreak />
        </React.Fragment>
      ))}
    </Section>
  );
};

export default HeroMaskCards;
